// SERVIS · presentation · bilanço sayaçlar

import { useRef } from "react";
import { SectionShell } from "@/features/landing/components/SectionShell";
import { COPY } from "@/features/landing/content/landing-copy";
import { useServisMotion } from "./Servis.motion";
import styles from "./Servis.module.css";

export function Servis() {
  const scopeRef = useRef<HTMLElement | null>(null);
  useServisMotion(scopeRef);

  return (
    <SectionShell id="servis" ariaLabelledBy="servis-title" tone="ink" container="default">
      <div className={styles.servis} ref={scopeRef as unknown as React.RefObject<HTMLDivElement>}>
        <header className={styles.servis__head}>
          <div>
            <p className={styles.servis__eyebrow}>{COPY.servis.chapter} · {COPY.servis.eyebrow}</p>
            <h2 className={styles.servis__title} id="servis-title">{COPY.servis.title}</h2>
          </div>
          <p className={styles.servis__body}>{COPY.servis.body}</p>
        </header>

        <div className={styles.servis__counters} role="list">
          {COPY.servis.counters.map((c) => (
            <div key={c.label} className={styles.servis__counter} role="listitem">
              <span className={styles.servis__num} aria-label={`${c.num}${c.suffix} ${c.label}`}>
                {c.num.toLocaleString("tr-TR")}<em>{c.suffix}</em>
              </span>
              <span className={styles.servis__label}>{c.label}</span>
            </div>
          ))}
        </div>
      </div>
    </SectionShell>
  );
}